module.exports = __webpack_public_path__ + "img/VANIA.49af2d54.jpeg";